import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { useReport } from "../../context/report";

export default function EficienciaBaixaDia() {
    const [filteredData, setFilteredData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [groups, setGroups] = useState([]);

    const { data } = useReport();

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(rowData[props.field]) + "%";
    }

    useEffect(() => {
        if(selectedGroup !== null) {
            let _filteredData = data.dados.filter((element) => {
                return element.grupo === selectedGroup;
            });

            setFilteredData(_filteredData);
        }
    }, [data, selectedGroup]);

    useEffect(() => {
        let _groups = [];

        data.dados.forEach((item) => {
            let index = _groups.findIndex((element) => {
                return element === item.grupo;
            });

            if(index === -1) {
                _groups.push(item.grupo);
            }
        });

        _groups = _groups.sort((a,b) => { return a - b });

        setGroups(_groups);
    }, [data]);

    return (
        <div
        >
            <div className="p-d-flex p-flex-row p-jc-around p-p-2" style={{ border: "1px solid black",borderBottom: "none" }}>
                <h2 className="p-m-0">TEARES COM EFICIÊNCIA BAIXA</h2>
                <h3 className="p-m-0">TURMA {data.turma}</h3>
                <h3 className="p-m-0">{data.data}</h3>
            </div>

            <div className="p-d-flex p-flex-row p-jc-around p-p-2 p-mb-2" style={{ border: "1px solid black" }}>
                <h3 className="p-m-0">Eficiência Geral: {data.eficiencia_geral}%</h3>
                <h3 className="p-m-0">Eng / Reeng: {data.geral.engreeng}</h3>
                <h3 className="p-m-0">Manutenção: {data.geral.manutencao}</h3>
                <h3 className="p-m-0">Trama: {data.geral.trama}</h3>
                <h3 className="p-m-0">Urdume: {data.geral.urdume}</h3>
            </div>

            <div className="p-grid p-d-flex p-flex-row p-jc-between p-mt-2 p-mb-2">
                {groups.map((group, index) => (
                    <Button 
                        className={"p-col p-mr-4 " + (selectedGroup === group ? "p-button-success" : "p-button-secondary")}
                        label={'GRUPO ' + group}
                        onClick={() => setSelectedGroup(group)}
                    />
                ))}
            </div>

            <DataTable
                responsiveLayout="scroll"
                size="small"
                value={filteredData}
            >
                <Column header="Tear" field="tear" sortable />
                <Column header="Artigo" field="artigo" sortable />
                <Column header="Eficiência" field="eficiencia" body={formatNumber} sortable />
                <Column header="Eng/Reeng" field="engreeng" sortable />
                <Column header="Manutenção" field="manutencao" sortable />
                <Column header="Trama" field="trama" sortable />
                <Column header="Urdume" field="urdume" sortable />
            </DataTable>
        </div>
    )
}